import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'components/Icon';

import { filterAttributes } from 'utils';

import './Button.scss';

const Button = ({
    children,
    className,
    disabled,
    href,
    white,
    primary,
    secondary,
    tertiary,
    flat,
    light,
    target,
    icon,
    title,
    onClick,
    type,
    gray,
    yellow,
    blue,
    block,
    download,
    compact,
    isActive = false,
    ...props
}) => {
    const classNames = cn('btn', className, {
        ['white']: white,
        ['primary']: primary,
        ['secondary']: secondary,
        ['tertiary']: tertiary,
        ['light']: light,
        ['icon']: icon,
        ['hasText']: !!children,
        ['flat']: flat,
        ['gray']: gray,
        ['yellow']: yellow,
        ['blue-bg']: blue,
        ['block']: block,
        ['compact']: compact,
        ['active']: isActive,
    });

    let Component = href ? "a" : "button";

    return (
        <Component
            className={classNames}
            disabled={disabled}
            href={href}
            onClick={onClick}
            target={target}
            title={title}
            type={type}
            download={download}
            rel={target && target === "_blank" ? "noopener noreferrer" : null}
            {...filterAttributes(props, /^data-/)}
        >
            {icon && <Icon icon={icon} />}
            <span className="btn-text">
                {children}
            </span>
        </Component>
    );
}

Button.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    href: PropTypes.string,
    white: PropTypes.bool,
    primary: PropTypes.bool,
    secondary: PropTypes.bool,
    tertiary: PropTypes.bool,
    light: PropTypes.bool,
    flat: PropTypes.bool,
    target: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string,
    gray: PropTypes.bool,
    yellow: PropTypes.bool,
    blue: PropTypes.bool,
    block: PropTypes.bool,
    download: PropTypes.bool,
    compact: PropTypes.bool,
    isActive: PropTypes.bool,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/Button.jsx